import Power from "../../assets/icons/Power"
import RightArrow from "../../assets/icons/RightArrow"
import Time from "../../../../assets/icons/Time"
import Locate from "../../../../assets/icons/Locate"
import Download from "../../../../assets/icons/Download"
import Screen from "../../../../assets/icons/Screen"
import Connect from "../../../../assets/icons/Connect"
import Door from "../../assets/icons/Door"
import Error from "../../assets/icons/Error"

export const ModeList = [
    {
        "id": 0,
        "icon": <Power />,
        "text": `Tap “DOT Inspection” in the menu & press “Start Inspection”. Let an officer to view
        your logs directly from your mobile device. Show this instruction card if requested.`
    },
    {
        "id": 1,
        "icon": <RightArrow />,
        "text": `An inspector may press arrows to view previous or next day’s logs`
    },
    {
        "id": 2,
        "icon": <Time />,
        "text": `An inspector may view the log form, the log graph and the log events with notes`
    },
    {
        "id": 3,
        "icon": <Door />,
        "text": `Exit the inspection mode by pressing back arrow in the left top corner of the app.
        `
    },
    {
        "id": 4,
        "icon": <Error />,
        "text": `Send Logs
        SFELDINC is capable of producing and transferring the ELD records via telematics
        transfer methods: Wireless Web services and Email. In order to send the ELD records via
        Web services a driver must press "DOT Inspection" menu item and then press "Send
        Logs" button. In order to send the ELD records via Email a driver must press "DOT
        Inspection" menu item, press "Email Logs", enter an email provided by an authorized
        safety official and press "Send" button.`
    },
]

export const ManualList = [
    {
        "id": 0,
        "icon": <Locate />,
        "title": "Locate ECM (diagnostic) port",
        "text": `Locate ECM (diagnostic) port inside of your vehicle. Look for 9-pin or 6-pin circular
        ports in heavy duty vehicles. Look for OBDII port in light/medium duty vehicles.`
    },
    {
        "id": 1,
        "icon": <Download />,
        "title": "Install ELD",
        "text": `Simply plug the provided cable into a vehicle ECM (diagnostic) and attach the other
        end to the ELD device. The dual fastener is provided for dash mounting.`
    },
    {
        "id": 2,
        "icon": <Screen />,
        "title": "Log into ELD Logbook App",
        "text": `Log in to ELD Logbook App on your tablet/smartphone with a username and password
        created during a sign up process or provided by a fleet manager.`
    },
    {
        "id": 3,
        "icon": <Connect />,
        "title": "Connect ELD",
        "text": `Select a vehicle from a list of available vehicles and your device will attempt to
        connect to ELD via Bluetooth. Green Bluetooth indicator at the top right corner
        means you are ready to start using ELD.
        `
    },
]